"use client";

import React, { useState } from "react";
import { SectionContentProps } from "../../types";
import LogoUploader from "../../sections/header/LogoUploader";
import { PiListBold, PiXBold } from "react-icons/pi";

export default function CorporateHeader({
  content,
  onContentChange,
  isSelected,
  defaultLogo,
}: SectionContentProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const navItems = content.navItems || ["Solutions", "Enterprise", "About", "Contact"];

  const handleLogoChange = (newLogoUrl: string) => {
    onContentChange?.({ ...content, logo: newLogoUrl });
  };

  return (
    <header
      className={`w-full transition-all relative z-50 bg-white border-b border-slate-200 ${isSelected ? "ring-2 ring-blue-500 z-50" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between py-4">
        <div className="flex items-center flex-shrink-0">
          <LogoUploader
            currentLogo={content.logo}
            defaultLogo={defaultLogo || "CORP INC"}
            onLogoChange={handleLogoChange}
            heightClass="h-8"
            primaryColor="#0F172A"
            secondaryColor="#3B82F6"
            companyName={content.companyName || "CORP INC"}
            isEditing={!!onContentChange}
          />
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              className="text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors"
            >
              {item}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={content.ctaLink || "#login"}
            className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 font-semibold text-sm hover:bg-slate-50 transition-all shadow-xs"
          >
            {content.ctaText || "Client Login"}
          </a>
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-slate-600 hover:text-blue-600 p-2"
          >
            {isMobileMenuOpen ? <PiXBold className="h-6 w-6" /> : <PiListBold className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200 py-4 px-6 space-y-4">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-semibold text-slate-600 hover:text-blue-600 py-1"
            >
              {item}
            </a>
          ))}
          <a
            href={content.ctaLink || "#login"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-center py-2 rounded-lg border border-slate-300 text-slate-700 font-semibold text-sm shadow-xs"
          >
            {content.ctaText || "Client Login"}
          </a>
        </div>
      )}
    </header>
  );
}
